import React from 'react';
import { Modal, Input, Form, Select } from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    idEstablecimiento: values.idEstablecimiento.key,
                    idTipoCaja: values.idTipoCaja.key

                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Caja" : "Modificar Caja"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaEstablecimiento.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-12 form-group">
                            <Form.Item label="Tipo Caja">
                                {getFieldDecorator("idTipoCaja", {
                                    initialValue: this.props.formValues.idTipoCaja
                                        ? { key: this.props.formValues.idTipoCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Tipo Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tipos.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)